import React, { useEffect, useRef } from 'react';

const Hero = () => {
  const videoRef = useRef(null);

  // React no escribe el atributo `muted` en el HTML ni lo aplica al hidratar. Sin él, Chrome
  // bloquea el autoplay a quien visita por primera vez y solo se ve el póster.
  // defaultMuted lo añade como atributo (también al HTML prerenderizado) y muted lo aplica ya.
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.defaultMuted = true;
    video.muted = true;
    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {});
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <video
        ref={videoRef}
        className="hero-video"
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        poster="/LandingPageAssets/Movies/Intro-poster.webp"
      >
        <source src="/LandingPageAssets/Movies/Intro.mp4" type="video/mp4" />
        Tu navegador no soporta la reproducción de videos.
      </video>
      <div className="hero-overlay"></div>
      <img src="/LandingPageAssets/Logos/jk-logo-full-transparent.png" alt="J&K Realty" className="hero-watermark" width="1200" height="271" />
      <div className="hero-content">
        <h1 className="hero-title">
          Donde tus sueños encuentran <span className="accent">el espacio perfecto</span>
        </h1>
        <p className="hero-subtitle">
          Espacios que abrazan tu estilo de vida
        </p>
        <div className="hero-cta">
          <button className="btn btn-primary" onClick={() => scrollToSection('properties')}>Ver Propiedades</button>
          <a href="https://wa.me/593995410584" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">Consulta Gratuita</a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
